export const DRAWER_TYPES = {
  DRAWER_OPEN_SET_SELECTED: "DRAWER_OPEN_SET_SELECTED",
  DRAWER_CLOSE_SELECTED: "DRAWER_CLOSE_SELECTED",
  DRAWER_WIDTH_SET_SELECTED: "DRAWER_WIDTH_SET_SELECTED",
  APP_BAR_ITEM_SET_SELECTED: "APP_BAR_ITEM_SET_SELECTED",
  SUB_MENU_ITEMS_SET_SELECTED: "SUB_MENU_ITEMS_SET_SELECTED",
  SUB_MENU_ITEMS_CLEAR_SELECTED: "SUB_MENU_ITEMS_CLEAR_SELECTED",
  SUB_MENU_VISIBILITY_SET_SELECTED: "SUB_MENU_VISIBILITY_SET_SELECTED",
  SUB_MENU_VISIBILITY_CLEAR_SELECTED: "SUB_MENU_VISIBILITY_CLEAR_SELECTED",
  SUB_MENU_ITEM_SET_SELECTED: "SUB_MENU_ITEM_SET_SELECTED",
  SUB_MENU_ITEM_CLEAR_SELECTED: "SUB_MENU_ITEM_CLEAR_SELECTED",
  // DRAWER_CLOSE_SELECTED: "DRAWER_CLOSE_SELECTED",
};
